import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, WritableSignal, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { FiltersPanelComponent } from 'src/app/shared/components/filters/filters-panel/filters-panel.component';
import { FiltersGroupComponent } from 'src/app/shared/components/filters/filters-group/filters-group.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';
import { InputDatetimeComponent } from 'src/app/shared/components/inputs/input-datetime/input-datetime.component';
import { ElaborazioneSelectComponent } from '../elaborazione-select/elaborazione-select.component';
import { ElaborazioneControlliComponent } from "../../controlli/elaborazione-controlli/elaborazione-controlli.component";
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { InputDateComponent } from "../../../shared/components/inputs/input-date/input-date.component";

@Component({
  selector: 'app-filters-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDividerModule,
    FiltersPanelComponent,
    FiltersGroupComponent,
    InputTextComponent,
    InputDatetimeComponent,
    ElaborazioneSelectComponent,
    ElaborazioneControlliComponent,
    InputDateComponent
],
  templateUrl: './filters-form.component.html',
  styleUrl: './filters-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersFormComponent implements OnInit {
  @Input() form!: FormGroup;

  ngOnInit(): void {
    this.form.addControl('idElaborazione_equals', new FormControl<string | null>(null, []));
    this.form.addControl('type_equals', new FormControl<string | null>(null, []));
    this.form.addControl('content_equals',  new FormControl<string | null>(null, []));
    this.form.addControl('statoElaborazione_equals',  new FormControl<string | null>(null, []));
    this.form.addControl('createdAt_equals', new FormControl(null, []));
    //this.form.addControl('createdAt_equals', new FormControl(0, [Validators.required]));

    this.form.get('createdAt_equals')?.valueChanges.subscribe((e) => {
        const newDate = this.toLocalISOString(new Date(e));
        this.form.get('createdAt_equals')?.setValue(newDate, { emitEvent: false });
        
      });
  }

  toLocalISOString(date:any) {
    let tzOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    let localDate = new Date(date.getTime() - tzOffset).toISOString().split('T')[0];
    return localDate;
  }
}
